<div class="card plan-card container-fluid" [ngClass]="plan.featured ? 'plan-card-featured': ''">
  <div class="row">
    <div class="col-8 col-md-3 border-right">
      <div class="row px-3">
        <div class="col-12 py-3 border-bottom text-center">
          <span class="d-block font-weight-bold font-size-md">
            @if (showDisclaimers) { {{plan.name}} [{{plan.contractId}}-{{plan.hfId}}] } @else { {{plan.name}} [ID# {{plan.hfId}}] }
          </span>
        </div>
      </div>
      <div class="row px-3">
        <div class="col-12 py-3 text-center">
          <span class="font-weight-bold font-size-lg text-success">${{plan.premium}}</span>
          @if (!showDisclaimers && plan.lob === AppConstants.Lob.IBP) {
          <sup class="font-weight-bold font-size-md text-secondary">†</sup>
          } @if ((plan.lob === AppConstants.Lob.IBP || plan.lob === AppConstants.Lob.MPPO) && showDisclaimers) {
          <sup class="font-weight-bold font-size-md text-secondary">*</sup>
          } @if (showDisclaimers) {
          <span class="font-weight-bold font-size-md"> {{premiumLabelKey | translate}}</span>
          } @else {
          <span class="d-block mt-1">{{'common.planItem.perMonth.2026' | translate}}</span>
          }
        </div>
      </div>
      <div class="row px-3 d-block d-md-none">
        <div class="col-12 py-3 border-top text-center">
          <a (click)="$event.preventDefault();showBenefitsModal()" href="#"
            >{{'common.planItem.showBenefits' | translate}}
            <fa-icon [icon]="['far', 'clone']"></fa-icon>
          </a>
        </div>
      </div>
    </div>
    <div class="col-7 pt-3 d-none d-md-block">
      <div class="row">
        <div class="col-12">
          <span class="font-weight-bold font-size-md">{{'common.planItem.benefitsInclude' | translate}}</span>
        </div>
      </div>
      <div class="row font-size-xs">
        @if (plan?.benefits?.col1) {
        <div class="col-6 pb-3">
          <ul class="m-0 pl-3">
            @for (benefit of plan.benefits.col1; track benefit) {
            <li class="pt-2">{{benefit}}</li>
            }
          </ul>
        </div>
        } @if (plan?.benefits?.col2) {
        <div class="col-6 pb-3">
          <ul class="m-0 pl-3">
            @for (benefit of plan.benefits.col2; track benefit) {
            <li class="pt-2">{{benefit}}</li>
            }
          </ul>
        </div>
        }
      </div>
    </div>
    <div class="col-4 col-md-2 border-left align-self-center">
      <div class="row px-3 pt-3 pb-0">
        <div class="col-12 p-0">
          @if (!selected) {
          <button (click)="emitSelectedPlanEvent()" class="btn btn-block btn-success text-capitalize p-3">
            {{'common.buttonLabels.select' | translate}}
          </button>
          } @if (selected) {
          <button (click)="emitSelectedPlanEvent()" class="btn btn-block btn-warning text-capitalize p-3">
            <fa-icon [icon]="['fas', 'check']"></fa-icon>
            @if (plan.additionalBenefits?.length) {
            <span class="badge badge-danger badge-pill border border-light">{{plan.additionalBenefits.length}}</span>
            }
          </button>
          }
        </div>
      </div>
      <div class="row p-3">
        <div class="col-12 p-0">
          <button (click)="showDownloadsModal()" class="btn btn-block btn-outline-success p-2 p-md-3">
            {{'common.buttonLabels.downloadPDF' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
